/*
 * Public API Surface of some-lib
 */

export * from './lib/some-lib.service';
export * from './lib/some-lib.component';
export * from './lib/some-lib.module';
